import { useCallback, useState } from 'react'

function useHouseConsignmentRowExpansion() {
  const [expandedHouseConsignmentId, setExpandedHouseConsignmentId] = useState<number | null>(null)

  const toggleHouseConsignmentExpansion = useCallback((id: number) => {
    setExpandedHouseConsignmentId((prev) => (prev === id ? null : id))
  }, [])

  const collapseAll = useCallback(() => {
    setExpandedHouseConsignmentId(null)
  }, [])

  return {
    expandedHouseConsignmentId,
    toggleHouseConsignmentExpansion,
    collapseAll,
    isExpanded: (id: number) => expandedHouseConsignmentId === id,
  }
}

export default useHouseConsignmentRowExpansion
